/**
 * Seller intake analytics event taxonomy (Sell Your Car M9).
 * Naming: lowercase_snake_case — matches AutoMapa analytics conventions.
 */

/** @readonly */
export const SELLER_INTAKE_ANALYTICS_EVENTS = Object.freeze({
  PAGE_VIEWED: "seller_intake_page_viewed",
  PRIMARY_CTA_CLICKED: "seller_intake_primary_cta_clicked",
  SECONDARY_CTA_CLICKED: "seller_intake_secondary_cta_clicked",
  FORM_STARTED: "seller_intake_form_started",
  FIELD_CHANGED: "seller_intake_field_changed",
  VALIDATION_ERROR: "seller_intake_validation_error",
  SUBMIT_ATTEMPTED: "seller_intake_submit_attempted",
  SUBMIT_SUCCEEDED: "seller_intake_submit_succeeded",
  SUBMIT_FAILED: "seller_intake_submit_failed",
  DUPLICATE_DETECTED: "seller_intake_duplicate_detected",
  SPAM_REJECTED: "seller_intake_spam_rejected",
  RATE_LIMITED: "seller_intake_rate_limited",
  RESET_CLICKED: "seller_intake_reset_clicked",
  FORM_ABANDONED: "seller_intake_form_abandoned",
});

/** Maps normalized submission status → analytics event name. */
export const SELLER_SUBMISSION_STATUS_EVENT_MAP = Object.freeze({
  received: SELLER_INTAKE_ANALYTICS_EVENTS.SUBMIT_SUCCEEDED,
  duplicate: SELLER_INTAKE_ANALYTICS_EVENTS.DUPLICATE_DETECTED,
  spam_rejected: SELLER_INTAKE_ANALYTICS_EVENTS.SPAM_REJECTED,
  rate_limited: SELLER_INTAKE_ANALYTICS_EVENTS.RATE_LIMITED,
  validation_error: SELLER_INTAKE_ANALYTICS_EVENTS.SUBMIT_FAILED,
  service_error: SELLER_INTAKE_ANALYTICS_EVENTS.SUBMIT_FAILED,
  network_error: SELLER_INTAKE_ANALYTICS_EVENTS.SUBMIT_FAILED,
  unknown_error: SELLER_INTAKE_ANALYTICS_EVENTS.SUBMIT_FAILED,
});

/** Whitelisted analytics payload keys (M9). */
export const SELLER_INTAKE_ANALYTICS_ALLOWED_KEYS = Object.freeze([
  "sourcePage",
  "sourceComponent",
  "sourceAction",
  "route",
  "formStep",
  "fieldName",
  "errorField",
  "errorCategory",
  "errorFields",
  "primaryErrorField",
  "sellerType",
  "preferredContactMethod",
  "ownershipStatus",
  "vehicleYearBucket",
  "mileageBucket",
  "askingPriceBucket",
  "cityProvided",
  "departmentProvided",
  "emailProvided",
  "notesProvided",
  "hasPhotos",
  "resultStatus",
  "retryable",
  "viewportCategory",
  "deviceCategory",
  "validationErrorCount",
  "submitAttemptCount",
  "elapsedTimeBucket",
  "analyticsDomain",
  "eventSource",
  "citySlug",
  "departmentSlug",
  "started",
  "submitted",
  "lastCompletedStep",
  "changedFieldCount",
  "currentPath",
  "referrer",
  "utmSource",
  "utmMedium",
  "utmCampaign",
  "utmContent",
  "utmTerm",
  "locale",
  "pagePath",
  "pageType",
]);
